export default __webpack_public_path__ + "static/media/bg-08.0df37686.jpg";